export const SELL_HOME_MODAL_STRINGS = {
  'sellHomeModal.title': 'Looking to sell\u00a0your\u00a0home?',
  'sellHomeModal.subtitle':
    'Apply management fees paid to date as a discount towards our ',
  'sellHomeModal.subtitleBold': '6% brokerage fee.',
  'sellHomeModal.title2':
    'The same extraordinary Belong\u00a0service, now\u00a0for\u00a0selling.',
  'sellHomeModal.inquireWith':
    'Inquire with Owen Savir, Belong’s\u00a0President',
  'sellHomeModal.mail': 'president@belonghome.com',
  'sellHomeModal.subject': 'Inquire about selling with Belong',
  'sellHomeModal.ctaLabel': 'Inquire Now',
  'sellHomeModal.realestatelicense': 'CA DRE License #02082345',
};
